import {NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {ComponentsModule} from '../components/components.module';
import {TranslateModule} from '@ngx-translate/core';
import {PipesModule} from '../../pipes/pipes.module';
import {SimulatorRoutingModule} from './simulator-routing.module';
import {SimulatorPage} from './simulator-page/simulator.page';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        SimulatorRoutingModule,
        ComponentsModule,
        PipesModule,
        TranslateModule.forChild()
    ],
    declarations: [
        SimulatorPage
    ],
    schemas: [
        NO_ERRORS_SCHEMA
    ]
})
export class SimulatorModule {
}
